module.exports = __webpack_public_path__ + "static/media/inline.289acc1c.svg";